<script type="text/javascript">
// 定义属性参数
const test = 123;

// 暴露出这些属性
export default {
  test,
};
</script>



// WEBPACK FOOTER //
// src/common/data.vue